"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOlapicConfig = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _utils = require("./utils");
/* istanbul ignore file -- api */

const useGetOlapicConfig = ({
  type,
  categoryId
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const updatedType = (0, _react.useMemo)(() => typeof type === 'number' ? (0, _utils.remapType)(type) : type, [type]);
  const {
    data,
    error
  } = (0, _staticApiClientReact.useGetTenantApplicationsOlapicConfiguration)(tenant, {
    olapicType: updatedType,
    lang: language,
    categoryId: type === 'Category' ? categoryId : undefined
  }, {
    swr: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false
    }
  });
  return {
    data: {
      apiKey: data?.apiKey,
      hideCaption: data?.hideCaption ?? false,
      olapicType: updatedType
    },
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- bad api typing, it can return null
    isEmpty: data === null && error === undefined,
    isLoading: data === undefined && error === undefined
  };
};
exports.useGetOlapicConfig = useGetOlapicConfig;
